import { HttpClient, HttpResponse } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SearchYourProjectsFields } from '../../../features/feature-manage-projects/models/mp-search-your-projects-fields.interface'
import { SearchProjectResult } from '../../../features/feature-search-projects/models/sp-result.interface'
import { BasicRequest } from '../../models/interfaces/basic-request.interface'
import { BasicResult } from '../../models/interfaces/basic-result.interface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'

@Injectable({ providedIn: 'root' })
export class FeatureMYPService {
   private _cn = this.constructor.name
   private _httpClient = inject(HttpClient)
   private _logService = inject(LogService)
   private _configService = inject(ConfigService)

   search(request: BasicRequest<SearchYourProjectsFields>): Observable<BasicResult<SearchProjectResult[], BasicRequest<SearchYourProjectsFields>>> {
      this._logService.info(this._cn, this.search.name, this._logService.START)
      this._logService.info(this._cn, this.search.name, 'search request body: ', request)
      return this._httpClient.post<BasicResult<SearchProjectResult[], BasicRequest<SearchYourProjectsFields>>>(
         `${this._configService.apiUrl}/solr/projects:search`,
         request
      )
   }

   exportExcelResults(searchFields?: BasicRequest<SearchYourProjectsFields>): Observable<HttpResponse<Blob>> {
      this._logService.info(this._cn, this.exportExcelResults.name, this._logService.START)
      this._logService.debug(this._cn, this.exportExcelResults.name, 'search fields:', searchFields)
      return this._httpClient.post<Blob>(`${this._configService.apiUrl}` + `/solr/projects:export`, searchFields, {
         headers: { Accept: '*/*' },
         responseType: 'blob' as 'json',
         observe: 'response',
      })
   }
}
